.icon {
  cursor: pointer;
}
